/**
 * Master Sheet Formula: Thread Size
 *
 * Formula:
 * =_xlfn.LET(
 *  _xlpm.fullList, _xlfn.XLOOKUP('Master Sheet'!H4, 'Thread Blank Diameter III.'!$K$4:$AE$4, 'Thread Blank Diameter III.'!$K$5:$AE$75),
 *  _xlpm.result, IF(
 *      OR(ISNUMBER(SEARCH("Class", 'Master Sheet'!I4)), ISNUMBER(SEARCH("M", 'Master Sheet'!I4))),
 *      _xlfn._xlws.FILTER(_xlpm.fullList, ISNUMBER(SEARCH("M", _xlpm.fullList))),
 *      IF(
 *          ISNUMBER(SEARCH("Grade", 'Master Sheet'!I4)),
 *          _xlfn._xlws.FILTER(_xlpm.fullList, ISERROR(SEARCH("M", _xlpm.fullList))),
 *          _xlpm.fullList
 *      )
 *  ),
 *  TRANSPOSE(_xlpm.result)
 *
 * Variables:
 * - H4: Fastener Type
 * - I4: Material
 *
 * Notes:
 * - This formula is part of data validation and not an actual formula that we can parse.
 */

import { StandardResult } from '@calculations/utilities/result';
import type { StringListMapDataSchema } from '@snap-types/models/auto-configurator-data-set';
import { err, ok } from 'neverthrow';

type Inputs = {
  fastenerType: string;
  material: string;
  threadSizeOptions: StringListMapDataSchema;
};

export function getThreadSizeOptions({
  fastenerType,
  material,
  threadSizeOptions,
}: Inputs): StandardResult<string[]> {
  const normalizedFastenerType = fastenerType.toLowerCase();
  const list =
    threadSizeOptions[fastenerType] ??
    threadSizeOptions[normalizedFastenerType];

  if (!list) {
    return err({
      message: 'Fastener type not found',
      context: {
        fastenerType,
        material,
        threadSizeOptions,
      },
    });
  }

  // @NOTE(NT): As of 2025-11-24, no materials in the spreadsheet contain "M".
  if (material.includes('M') || material.includes('Class')) {
    return ok(list.filter((item) => item.includes('M')));
  }

  if (material.includes('Grade')) {
    return ok(list.filter((item) => !item.includes('M')));
  }

  return ok(list);
}
